import React from 'react';
import { connect } from 'react-redux';
import memoize from 'lodash/memoize';

import { modalHide, putGuestInCabin, removeGuestFromCabin, setActiveCabin } from 'store/actions';
import { fromReservation } from 'store/selectors';

import { SelectCabinModal } from 'components';

class SelectCabinModalContainer extends React.Component {
  shouldComponentUpdate(nextProps) {
    return ['cabins', 'guests', 'activeCabin', 'isAllGuestsInCabin'].reduce((prev, key) => prev || (this.props[key] !== nextProps[key]), false);
  }
  render() {
    return <SelectCabinModal {...this.props} />;
  }
}

const getCachedNonAnomynousGuests = memoize(
  (guests, get) => guests.filter(g => get(g)),
  guests => guests.join(''),
);

const mapStateToProps = (state, { departureId }) => {
  const { routeName, cabins, guests } = fromReservation.getDeparture(state, departureId);
  const activeCabin = fromReservation.getActiveCabin(state, departureId);
  const selectedGuests = activeCabin
    ? fromReservation.getCabin(state, activeCabin).guests.reduce((obj, id) => ({
      ...obj,
      [id]: true,
    }), {})
    : {};
  return {
    routeName,
    cabins,
    guests: getCachedNonAnomynousGuests(guests, id => !fromReservation.getGuest(state, id).isAnonymous),
    activeCabin,
    selectedGuests,
    isAllGuestsInCabin: fromReservation.isAllGuestsInCabin(state, departureId),
    isCabinFull: cabins.map(id => fromReservation.isCabinFull(state, id)),
    isAllCabinsPopulated: fromReservation.isAllCabinsPopulated(state, departureId),
    cabinsAllocated: fromReservation.isCabinsAllocated(state, departureId),
  };
};

const mapDispatchToProps = (dispatch, { departureId }) => ({
  onClose: () => dispatch(modalHide(`selectCabin-${departureId}`)),
  onPutGuestInCabin: (guest, departure, cabin) => dispatch(putGuestInCabin(guest, departure, cabin)),
  onRemoveGuestFromCabin: (guest, departure, cabin) => dispatch(removeGuestFromCabin(guest, departure, cabin)),
  setActiveCabin: id => dispatch(setActiveCabin(id, departureId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectCabinModalContainer);



// WEBPACK FOOTER //
// ./src/containers/SelectCabinModal.js